import {toast} from 'react-toastify';

let initialState = {
	infos: [],
	create: [],
	update: [],
	delete: [],
	ordre: [],
	settings: [],
	settingsUpdate: []
};

const notifySuccess = (message) =>
	toast.success(message, {
		position: 'top-right',
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined
	});

const notifyError = (message) =>
	toast.error(message, {
		position: 'top-right',
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined
	});

const getHomemessagesInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_HOMEMESSAGES_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'POST_HOMEMESSAGE_RETURN':
			const arrayMessage = [action.payload.data];
			let newStateAdd;
			if (action.payload.status === 201) {
				newStateAdd = {...state.infos, data: (state.infos.data || []).concat(arrayMessage)};
				notifySuccess('Message ajouté !');
			} else {
				newStateAdd = state.infos;
				notifyError('Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {
				create: action.payload,
				infos: newStateAdd
			});

		case 'PUT_HOMEMESSAGE_RETURN':
			let array = [];
			let newStateUpdate;
			if (action.payload.status === 202) {
				array = (state.infos.data || []).map((item) => {
					return item.uuid === action.payload.data.uuid ? action.payload.data : item;
				});
				newStateUpdate = {...state.infos, data: array};
				notifySuccess('Message mis à jour !');
			} else {
				newStateUpdate = state.infos;
				notifyError('Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {
				update: action.payload,
				infos: newStateUpdate
			});

		case 'PUT_HOMEMESSAGES_ORDRE_RETURN':
			if (action.payload.status === 202) {
				notifySuccess('Ordre mis à jour !');
			} else {
				notifyError('Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {ordre: action.payload});

		case 'DEL_HOMEMESSAGE_SAGAS':
			const messages = state.infos.data || [];
			const indexMessage = messages.findIndex((index) => index.uuid === action.payload);
			const newStateDelete = {...state.infos, data: messages.filter((item, i) => i !== indexMessage)};

			return Object.assign({}, state, {infos: newStateDelete});
		case 'DEL_HOMEMESSAGE_RETURN':
			if (action.payload.status === 202) {
				notifySuccess('Message supprimé !');
			} else {
				notifyError('Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {delete: action.payload});

		case 'GET_HOMESETTINGS_RETURN':
			return Object.assign({}, state, {settings: action.payload});

		case 'PUT_HOMESETTINGS_RETURN':
			if (action.payload.status === 202) {
				notifySuccess('Durée du carrousel mise à jour !');
			} else {
				notifyError(action.payload?.data?.message || 'Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {settingsUpdate: action.payload, settings: action.payload.status === 202 ? action.payload : state.settings});

		default:
			return state;
	}
};

export default getHomemessagesInfos;
